<template>
  <v-dialog
    v-model="dialog"
    width="600px"
    :fullscreen="$vuetify.breakpoint.smAndDown"
  >
    <v-card>
      <v-toolbar color="#FFB300" dense class="elevation-0" dark>
        <v-card-title>Thêm Cơ Sở Vật Chất</v-card-title>
        <v-spacer />
        <v-btn icon dark @click="dialog = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="pt-6">
        <facility-new-form ref="form" />
      </v-card-text>
      <v-card-actions class="pr-6 pb-5 mt-n8">
        <v-spacer></v-spacer>
        <v-btn depressed class="px-4" color="success" @click="save">
          <v-icon>add</v-icon>Thêm</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import FacilityNewForm from '@/components/basic/form/FacilityForm.vue'

export default {
  props: {
    state: Boolean
  },
  components: { FacilityNewForm },
  data: () => ({
    dialog: false
  }),
  methods: {
    ...mapActions('facilities', ['fetchFacilities', 'createFacility']),
    async save() {
      const data = this.$refs.form.getData()
      await this.createFacility({
        data: {
          ...data,
          status: 'inventory',
          department: this.department.id
        }
      })
      this.dialog = false
      this.reset()
    },
    reset() {
      this.$refs.form.reset()
    }
  },
  created() {
    this.fetchFacilities()
  },
  computed: {
    ...mapGetters('facilities', ['facilities']),
    ...mapGetters('app', ['department'])
  },
  watch: {
    state(state) {
      this.dialog = true
    }
  }
}
</script>
<style scoped></style>
